import React from 'react'
import PropTypes from 'prop-types'
import { GridActionsCellItem } from '@mui/x-data-grid-pro'
import BillingLockedTooltip from 'components/billing/common/lock-billing-date/BillingLockedTooltip'
import { useDispatch } from 'react-redux'
import api from 'api'
import { CACHE_TAG_INVOICE_LIST } from 'api/cacheTagTypes'
import { useInvoiceActionsDataGrid } from 'components/billing/common/useInvoiceActions'

const RenderGetInvoiceActionsDataCell = params => {
  const { row } = params
  const dispatch = useDispatch()

  const handleRefetch = (timeout = 0) => setTimeout(() => dispatch(api.util.invalidateTags([CACHE_TAG_INVOICE_LIST])), timeout)

  const { availableActions, handleAction, disabledProps } = useInvoiceActionsDataGrid(row, {
    handleRefetch,
  })

  return availableActions
    .map(action => {
      const baseProps = {
        key: action.key,
        showInMenu: true,
        label: action.label,
        onClick: () => handleAction(action.key),
        sx: action.style || {},
      }

      if (action.disabled) {
        baseProps.sx = { ...baseProps.sx, ...disabledProps.sx }
      }

      return (
        <GridActionsCellItem
          {...baseProps}
          label={<BillingLockedTooltip isLocked={action.isLocked && action.disabled}>{action.label}</BillingLockedTooltip>}
          {...(action.disabled ? {} : { onClick: baseProps.onClick })}
        />
      )
    })
    .filter(Boolean)
}

RenderGetInvoiceActionsDataCell.propTypes = {
  row: PropTypes.object,
}

export default RenderGetInvoiceActionsDataCell
